<template>
  <div class="container mt-12 pb-10">
    <d-table class="pt-5" :loading="loading" :data="users" paginated backend-pagination :total="total" striped :per-page="pagination.pageSize" default-sort-direction="desc" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" :search.sync="filter" show-search @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h1 class="text-primary-500 mr-3">
          Admin Users
        </h1>
      </template>
      <template #action-buttons-right>
        <d-btn @click="launchAddUserModal">
          + Add User
        </d-btn>
      </template>

      <template slot-scope="props">
        <d-table-column field="firstName" label="Name" :row="props.row">
          {{ props.row.firstName }} {{ props.row.lastName }}
        </d-table-column>
        <d-table-column field="email" label="Email" :row="props.row" />
        <d-table-column field="passwordExpired" label="Password Expired" centered class="text-center">
          <d-icon v-if="props.row.passwordExpired" icon="check" class="text-green-500" />
        </d-table-column>
        <d-table-column field="active" label="Active" centered class="text-center">
          <d-icon v-if="props.row.active" icon="check" class="text-green-500" />
        </d-table-column>
        <d-table-column class="text-right">
          <a href="javascript:;" @click="showEditModal(props.row)">
            <d-icon icon="edit" class="cursor-pointer text-primary-500 ml-4" />
          </a>
          <a href="javascript:;" @click="showDeletePrompt(props.row)">
            <d-icon icon="trash" class="cursor-pointer text-red-500 ml-4" />
          </a>
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import UserModal from './components/UserModal.vue';

  export default {
    parent: true,

    data() {
      return {
        loading: false,
        users: [],
        total: 0,
        filter: '',
        pagination: {
          page: 1,
          pageSize: 50,
          sortField: 'firstName',
          sortOrder: 'desc',
        },
      };
    },

    watch: {
      pagination: {
        handler() {
          this.getUsersPaged();
        },
        deep: true,
      },

      filter() {
        this.getUsersPaged();
      },
    },

    mounted() {
      this.getUsersPaged();
    },

    methods: {
      async getUsersPaged() {
        const {
          page, pageSize, sortField, sortOrder,
        } = this.pagination;
        const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `filter=${this.filter}`].join('&');
        this.loading = true;
        const { data } = await axios.get(`/api/admin-users?${params}`);
        this.users = data.resultItems;
        this.total = data.totalRecords;
        this.loading = false;
      },

      launchAddUserModal() {
        this.$modal.open({
          parent: this,
          width: 650,
          component: UserModal,
          hasModalCard: true,
          events: {
            getUsersPaged: () => this.getUsersPaged(),
          },
        });
      },

      showEditModal(user) {
        this.$modal.open({
          parent: this,
          width: 650,
          component: UserModal,
          hasModalCard: true,
          props: {
            user,
          },
          events: {
            getUsersPaged: () => this.getUsersPaged(),
          },
        });
      },

      showDeletePrompt(user) {
        this.$dialog.confirm({
          title: 'Deleting User',
          message: `Are you sure you want to delete <b>${user.firstName} ${user.lastName}</b>? This action cannot be undone.`,
          confirmText: 'Delete User',
          confirmColor: 'error',
          onConfirm: async () => {
            await axios.delete(`/api/admin-users/${user.id}`);
            await this.getUsersPaged();
            this.$toast.open({
              message: 'User was deleted',
              color: 'success',
            });
          },
        });
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },
  };
</script>